import { Pipe, PipeTransform, inject } from '@angular/core';
import { FormattingOverrides } from '@zag/core/common';
import { FormattingService } from './formatting.service';

/**
 * Formats a numeric value using the active locale.
 *
 * Usage:
 * ```html
 * {{ myNumber | zagNumber }}
 * {{ myNumber | zagNumber : { minimumFractionDigits: 2, maximumFractionDigits: 2 } }}
 * ```
 */
@Pipe({
  name: 'zagNumber',
  pure: false,
})
export class ZagNumberPipe implements PipeTransform {
  private readonly formattingService = inject(FormattingService);

  transform(
    value: number | null | undefined,
    overrides?: FormattingOverrides & { minimumFractionDigits?: number; maximumFractionDigits?: number }
  ): string {
    if (value == null) {
      return '';
    }
    return this.formattingService.formatNumber(value, overrides);
  }
}
